export function uniqueTags(files: Array<{ tags: string[] }>): string[] {
  const seen = new Set<string>()
  const tags: string[] = []
  for (const file of files) {
    for (const tag of file.tags) {
      if (!tag || seen.has(tag)) continue
      seen.add(tag)
      tags.push(tag)
    }
  }
  tags.sort((left, right) => left.localeCompare(right))
  return tags
}

export function commonTags(files: Array<{ tags: string[] }>): string[] {
  if (!files.length) return []
  const [first, ...rest] = files
  return first.tags
    .filter((tag) => rest.every((file) => file.tags.includes(tag)))
    .slice()
    .sort((left, right) => left.localeCompare(right))
}

export function tagAlreadyExists(tags: string[], query: string): boolean {
  const needle = query.trim().toLocaleLowerCase()
  if (!needle) return false
  return tags.some((tag) => tag.toLocaleLowerCase() === needle)
}

export function filterTagSuggestions(tags: string[], query: string, exclude: string[] = [], limit = 8): string[] {
  const needle = query.trim().toLocaleLowerCase()
  const blocked = new Set(exclude.map((item) => item.toLocaleLowerCase()))
  const prefix: string[] = []
  const rest: string[] = []
  for (const tag of tags) {
    const lower = tag.toLocaleLowerCase()
    if (blocked.has(lower)) continue
    if (needle && !lower.includes(needle)) continue
    if (!needle || lower.startsWith(needle)) prefix.push(tag)
    else rest.push(tag)
  }
  return [...prefix, ...rest].slice(0, limit)
}
